export class UpdateRelatedProduct {
    ProductId: string;
    RelatedProductIds: string;
}
export class UpdateRelatedProductModel {
    ProductId: number;
    RelatedProductIds: string;
}

export class RelatedProductListItem {
    ProductId: string;
    PageNumber: number = 1;
    PageSize: number = 4;
}

export class RelatedProductResponseModel {
    ProductSort: Array<ProductModel> = [];
    TotalPages: number;
}

export class ProductModel {
    priceFormatted: string;
    description: string;
    discountPercent: number;
    features: string;
    isDiscount: boolean;
    productId: number;
    id: number;
    productName: string;
    productPrice: number;
    productPriceFormatted: string;
    productTitle: string;
    fileTitle: string;
    productImage: any;
    imageLoader: boolean = true;
    isActive: string;
    isSale: string;
    isQuote: boolean;
    isShippingRequired: string;
                                                                                        
}

export class DeleteRelatedProductModel {
    RelatedProductIds :string;                                                                                                   
}
